module.exports = __webpack_public_path__ + "img/75577.7e6785cb.svg";